import { jsx as _jsx } from "@redneckz/uni-jsx/jsx-runtime";
import { JSX } from '@redneckz/uni-jsx';
import { useEffect } from '@redneckz/uni-jsx/lib/hooks';
import { useRegions } from '../../hooks/useRegions.js';
import { SelectControl } from '../../ui-kit/Select/SelectControl.js';
import { OUT_SERVICE_URL } from './constants.js';
import { validatorObj } from './getObjectValidator.js';
import { getValidation } from './getValidation.js';
export const LocalitiesField = JSX(({ field, input }) => {
    const fieldRegion = field('region');
    const regionKey = fieldRegion?.value?.key;
    const localities = useRegions(OUT_SERVICE_URL)
        ?.find((_) => _.code === regionKey)
        ?.localities?.map((_) => ({ key: _, text: _ }));
    useEffect(() => {
        if (regionKey !== '') {
            field?.('localities')?.onChange?.('');
        }
    }, [regionKey]);
    return (_jsx(SelectControl, { label: "\u041D\u0430\u0441\u0435\u043B\u0435\u043D\u043D\u044B\u0439 \u043F\u0443\u043D\u043A\u0442", placeholder: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043E\u0442\u0434\u0435\u043B\u0435\u043D\u0438\u0435", options: localities, ...getValidation(field('localities'), validatorObj.localities, input?.required), isSearch: true }));
});
//# sourceMappingURL=LocalitiesField.js.map